export default __webpack_public_path__ + "static/media/nicePerson.78c41817.png";